export type INotification =
  | {
      message: string;
      type: NotificationType;
      id: number;
      position?: SnackbarPosition;
    }
  | undefined;

export enum NotificationType {
  error = 'error',
  success = 'success',
  loading = 'loading',
}

export enum SnackbarPosition {
  Top = 'top',
  Bottom = 'bottom',
  LeftTop = 'leftTop',
  RightTop = 'RightTop',
  LeftBottom = 'LeftBottom',
  RightBottom = 'RightBottom',
}
